import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import OpenApiSpecIcon from "legacy-components/icons/OpenApiSpecIcon";
import { SpecEditor } from "./SpecEditor";

interface SpecDetailsProps {
  specName?: string;
  apiId: string;
  version: string;
  specId: string;
  specFile: string;
  specUrl?: string;
  refreshDeployments: ()=>void;
  serviceId: string;
}

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    borderWidth: "2px",
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    alignItems: "center",
    minHeight: "90px",
    minWidth: "300px",
    maxWidth: "500px",
    padding: "10px",
    justifyContent: "space-between",
    [theme.breakpoints.down("xs")]: {
      minWidth: 0,
      width: "100%",
    },
  },
  specIcon: {
    width: "50px",
    height: "50px",
  },
  specNameContainer: {
    minWidth: "120px",
    padding: "0 10px",
  },
  specNameText: {
    fontSize: "14px",
    fontWeight: 500,
    wordWrap: "break-word",
  },
}));

export const SpecDetails: React.FC<SpecDetailsProps> = ({ specName, apiId, version, specId, specFile, specUrl, refreshDeployments, serviceId }) => {
  const classes = useStyles();

  return (
    <Box className={classes.cardContainer}>
      <OpenApiSpecIcon className={classes.specIcon} />
      <Box className={classes.specNameContainer}>
        <Typography variant="body1" className={classes.specNameText}>
          {specName}
        </Typography>
      </Box>
      <SpecEditor apiId={apiId} version={version} specId={specId} specFile={specFile} specUrl={specUrl} refreshDeployments={refreshDeployments} serviceId={serviceId}>

      </SpecEditor>
    </Box>
  );
};
